import { useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { FILTER_USERS_QUERY } from "../graphql/query";
import { FilterUsers } from "../graphql/__generated_types__/FilterUsers";
import { debounce } from "throttle-debounce";

const DELAY_TIME = 1000;
type UserDisplay = { id: number; displayName: string };

export const useUserSearchQuery = (
  requiredUsers?: UserDisplay[],
  restrictedExternalMatterId?: number,
  restrictedClientId?: number
) => {
  const [users, setUsers] = useState<UserDisplay[]>(requiredUsers || []);

  const [getUsers, { loading }] = useLazyQuery<FilterUsers>(FILTER_USERS_QUERY, {
    onCompleted: ({ filterUsers: { users } }) => {
      setUsers([...(requiredUsers || []), ...users]);
    },
  });

  const delaySearch = debounce(DELAY_TIME, (displayName: string) => {
    getUsers({
      variables: { filter: { displayName }, restrictedExternalMatterId, restrictedClientId },
    });
  });

  const search = (displayName: string) => {
    delaySearch(displayName);
  };

  return { users, search, loading };
};
